module.exports = __webpack_public_path__ + "static/media/footer_logo_nomura-am@2x.8fda8f3f.jpg";